import {Locale} from './Locale';
declare var $: any;
declare var window: any;

export class ProtoBuf {
    public static instance: ProtoBuf;

    // state
    public endpoint: string;
    public payload: any;
    public callback: any;
    public responseEncoder;
    public requestEncoder;
    public requestEncoderPayload;
    public requestObject;
    public setCallback;
    public retryCount: number = 0;

    public triedToSend = false;
    public dependenciesLoaded = false;
    public dependencies = ['/js/protobuf.bundle.min.js'];

    public encryptedTransmissionKey;
    public transmissionPublicKey: number = 2;
    public transmissionPublicKeys = {
        1: 'MIIBCgKCAQEA9Z_CZzxiNUz8-npqI4V10-zW3AL7-M4UQDdd_17759Xzm0MOEfHOOsOgZxxNK1DEsbyCTCE05fd3Hz1mn1uGjXvm5HnN2mL_3TOVxyLU6VwH9EDInnj4DNMFifs69il3KlviT3llRgPCcjF4xrF8d4SR0_N3eqS1f9CBJPNEKEH-am5Xb_FqAlOUoXkILF0UYxA_jNLoWBSq-1W58e4xDI0p0GuP0lN8f97HBtfB7ijbtF-VxIXtxRy-4jA49zK-CQrGmWqIm5DzZcBvUtVGZ3UXd6LeMXMJOifvuCneGC2T2uB6G2g5yD54-onmKIETyNX0LtpR1MsZmKLgru5ugwIDAQAB',
        2: 'MIIBCgKCAQEAkOpym7xC3sSysw5DAidLoVF7JUgnvXejbieDWmEiD-DQOKxzfQqYHoFfeeix__bx3wMW3I8cAc8zwZ1JO8hyB2ON732JE2Zp301GAUMnAK_rBhQWmYKP_-uXSKeTJPiuaW9PVG0oRJ4MEdS-t1vIA4eDPhI1EexHaY3P2wHKoV8twcGvdWUZB5gxEpMbx5CuvEXptnXEJlxKou3TZu9uwJIo0pgqVLUgRpW1RSRipgutpUslBnQ72Bdbsry0KKVTlcPsudAnnWUtsMJNgmyQbESPm-aVv-GzdVUFvWKpKkAxDpNArPMf0xt8VL2frw2LDe5_n9IMFogUiSYt156_mQIDAQAB',
        3: 'MIIBCgKCAQEAyvxCWbLvtMRmq57oFg3mY4DWfkb1dir7b29E8UcwcKDcCsGTqoIhubU2pO46TVUXmFgC4E-Zlxt-9F-YA-MY7i_5GrDvySwAy4nbDhRL6Z0kz-rqUirgm9WWsP9v-X_BwzARqq83HNBuzAjf3UHgYDsKmCCarVAzRplZdT3Q5rnNiYPYSHzwfUhKEAyXk71UdtleD-bsMAmwnuYHLhDHiT279An_Ta93c9MTqa_Tq2Eirl_NXn1RdtbNohmMXldAH-C8uIh3Sz8erS4hZFSdUG1WlDsKpyRouNPQ3diorbO88wEAgpHjXkOLj63d1fYJBFG0yfu73U80aEZehQkSawIDAQAB',
        4: 'MIIBCgKCAQEA0TVoXLpgluaqw3P011zFPSIzWhUMBqXT-Ocjy8NKjJbdrbs53eRFKk1waeB3hNn5JEKNVSNbUIe-MjacB9P34iCfKtdnrdDB8JXx0nIbIPzLtcJC4HCYASpjX_TVXrU9BgeCE3NUtnIxjHDy8PCbJyAS_Pv299Q_wpLWnkkjq70ZJ2_fX-ObbQaZHwsWKbRZ_5sD6rLfxNACTGI_jo9-vVug6AdNq96J7nUdYV1cG-INQwJJKMcAbKQcLrml8CMPc2mmf0KQ5MbS_KSbLXHUF-81AsZVHfQRSuigOStQKxgSGL5osY4NrEcODbEXtkuDrKNMsZYhijKiUHBj9vvgKwIDAQAB',
        5: 'MIIBCgKCAQEAueOWC26w-HlOLW7s88WeWkXpjxK4mkjqngIzwbjnsU9145R51HvsILvjXJNdAuueVDHj3OOtQjfUM6eMMLr-3kaPv68y4FNusvB49uKc5ETI0HtHmHFSn9qAZvC7dQHSpYqC2TeCus-xKeUciQ5AmSfwpNtwzM6Oh2TO45zAqSA-QBSk_uv9TJu0e1W1AlNmizQtHX6je-mvqZCVHkzGFSQWQ8DBL9dHjviI2mmWfL_egAVVhBgTFXRHg5OmJbbPoHj217Yh-kHYA8IWEAHylboH6CVBdrNL4Na0fracQVTm-nOWdM95dKk3fH-KJYk_SmwB47ndWACLLi5epLl9vwIDAQAB',
        6: 'MIIBCgKCAQEA2PJRM7-4R97rHwY_zCkFA8B3llawb6gF7oAZCpxprl6KB5z2cqLAvUfEOBtnr7RIturX04p3ThnwaFnAR7ADVZWBGOYuAyaLzGHDI5mvs8D-NewG9vw8qRkTT7Mb8fuOHC6-_lTp9AF2OA2H4QYiT1vt43KbuD0Y2CCVrOTKzDMXG8msl_JvAKt4axY9RGUtBbv0NmpkBCjLZri5AaTMgjLdu8XBXCqoLx7qZL-Bwiv4njw-ZAI4jIszJTdGzMtoQ0zL7LBj_TDUBI4Qhf2bZTZlUSL3xeDWOKmd8Frksw3oKyJ17oCQK-EGau6EaJRGyasBXl8uOEWmYYgqOWirNwIDAQAB',
    };

    public static getInstance() {
        if (!ProtoBuf.instance) {
            ProtoBuf.instance = new ProtoBuf();
        }
        return ProtoBuf.instance;
    }

    constructor() {
        if (window.keeperPreload.apiEndpoint.indexOf('dev.keepersecurity.com') !== -1) {
            this.transmissionPublicKey = 2;
        } else if (window.keeperPreload.apiEndpoint.indexOf('qa.keepersecurity.com') !== -1) {
            this.transmissionPublicKey = 3;
        } else if (window.keeperPreload.apiEndpoint.indexOf('keepersecurity.com') !== -1) {
            this.transmissionPublicKey = 1;
        } else if (window.keeperPreload.apiEndpoint.indexOf('localhost') !== -1) {
            this.transmissionPublicKey = 1;
        }
    }

    ////////////////////////////////////////////

    public loadDependencies() {
        // Check if protobuf dependencies are already loaded
        if (
            typeof (window as any).KeeperCrypto !== 'undefined' &&
            typeof (window as any).KeeperCrypto.breachwatch_hmac512 === 'function'
        ) {
            // console.log('ProtoBuf dependencies already loaded');
            this.dependenciesReady();
            return;
        }

        // console.log('Loading ProtoBuf dependencies...');
        const self = this;
        this.dependencies.forEach((scriptSrc, i) => {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = false;
            if (scriptSrc.indexOf(this.dependencies[this.dependencies.length - 1]) > -1) {
                script.onload = this.dependenciesReady.bind(self);
            }
            document.body.appendChild(script);
        });
    }

    public dependenciesReady() {
        // console.log("%cProtoBuf was loaded successfully and is now enabled.", "color: green;");
        this.dependenciesLoaded = true;
        if (this.triedToSend) {
            this.sendAsync(this.endpoint, this.setCallback, this.payload, this.callback);
        }
    }

    ////////////////////////////////////////////

    public set(configuration: any) {
        this.requestObject = configuration.request;
        this.requestEncoder = configuration.api;
        this.requestEncoderPayload = configuration.apiPayload;
        this.responseEncoder = configuration.response;
    }

    ////////////////////////////////////////////

    // send(endpoint: string, payload: any, callback) {
    //     this.endpoint = endpoint;
    //     this.payload = payload;
    //     this.callback = callback;

    //     if (!this.dependenciesLoaded) {
    //         console.log('%cWaiting for ProtoBuf dependencies to load.', 'color: grey;');
    //         this.triedToSend = true;
    //         return;
    //     }

    //     try {
    //         this.sendRequestAsPB(this.endpoint, this.payload, this.callback);
    //     } catch (e) {
    //         console.error(e);
    //         this.callback(false, e);
    //     }
    // }

    public sendAsync(endpoint: string, setCallback, payload: any, callback) {
        this.endpoint = endpoint;
        this.payload = payload;
        this.callback = callback;
        this.setCallback = setCallback;

        if (!this.dependenciesLoaded) {
            //console.log("%cWaiting for ProtoBuf dependencies to load.", "color: grey;");
            this.triedToSend = true;
            return;
        }

        this.setCallback();

        try {
            this.sendRequestAsPB(this.endpoint, this.payload, this.callback);
        } catch (e) {
            console.error(e);
            this.callback(false, e);
        }
    }

    ////////////////////////////////////////////

    public publicKeyEncrypt(bytes, publicKey) {
        const public_key_hex = window.KeeperCrypto.base64urlsafe_to_hex(publicKey);
        const ASN1HEX = window.ASN1HEX;
        const pos = ASN1HEX.getPosArrayOfChildren_AtObj(public_key_hex, 0);
        const hN = ASN1HEX.getHexOfV_AtObj(public_key_hex, pos[0]);
        const hE = ASN1HEX.getHexOfV_AtObj(public_key_hex, pos[1]);
        const rsa = new window.RSAKey();
        rsa.setPublic(hN, hE);
        const result = window.KeeperCrypto.hex_to_bytes(
            rsa.encryptBinary(window.KeeperCrypto.bytes_to_hex(bytes))
        );
        return result;
    }

    ////////////////////////////////////////////

    public convertToBytes(str) {
        const arr = [];
        for (let pos = 0, len = str.length; pos < len; pos++) {
            arr.push(str.charCodeAt(pos));
        }
        return new Uint8Array(arr);
    }

    ////////////////////////////////////////////

    public convertToString(array) {
        return String.fromCharCode.apply(null, new Uint8Array(array));
    }

    ////////////////////////////////////////////

    public encryptRequestPB(
        publicKeyId,
        transmissionKey,
        encryptedTransmissionKey,
        encryptedSessionToken,
        data
    ) {
        const requestPayload = {
            payload: data,
            encryptedSessionToken,
            timeToken: undefined,
            apiVersion: 0,
        };

        // if (window.keeper.debug) {
        //     console.log("PROTOBUF ENDPOINT REQUEST:", requestPayload);
        // }

        const apiPayloadMsg = this.requestEncoderPayload.create(requestPayload);
        const apiPayloadBytes = this.requestEncoderPayload.encode(apiPayloadMsg).finish();
        const encryptedPayload = window.KeeperCrypto.base64urlsafe_to_bytes(
            window.KeeperAES256GCM.encrypt(apiPayloadBytes, transmissionKey)
        );

        const requestObj: any = {
            encryptedTransmissionKey,
            publicKeyId,
            locale: Locale.getInstance().getCurrentLocale(),
            encryptedPayload,
        };

        if (window.recaptchaToken) {
            requestObj.recaptcha = btoa(window.recaptchaToken);
        }

        if (window.keeper.debug) {
            console.log('PROTOBUF API REQUEST:', requestObj);
        }

        const requestMsg = this.requestEncoder.create(requestObj);
        const requestBytes = this.requestEncoder.encode(requestMsg).finish();
        return requestBytes;
    }

    public encodePB(request) {
        const encryptedRequest = request;

        for (const field in request) {
            const fieldType = this.requestObject.prototype[field].constructor;
            switch (fieldType) {
                case String:
                    encryptedRequest[field] = request[field];
                    break;
                case Array:
                    for (const i in request[field]) {
                        encryptedRequest[field][i] = this.encodePB(request[field][i]);
                    }
                    break;
                case Number:
                case Boolean:
                    encryptedRequest[field] = request[field];
                    break;
                case Uint8Array:
                    encryptedRequest[field] = window.KeeperCrypto.base64urlsafe_to_bytes(
                        request[field]
                    );
                    break;
                default:
                    encryptedRequest[field] = this.encodePB(request[field]);
            }
        }
        return encryptedRequest;
    }

    public decodePB(response, transmissionKey) {
        let responseBytes;
        if (typeof response === 'string') {
            responseBytes = this.convertToBytes(response);
        } else {
            responseBytes = new Uint8Array(response);
        }

        const decryptedBytes = window.KeeperAES256GCM.decryptToBytes(
            responseBytes,
            transmissionKey
        );
        const decryptedResponse = this.responseEncoder.decode(decryptedBytes);
        return JSON.stringify(decryptedResponse.toJSON());
    }

    public sendRequestAsPB(endpoint, payload, callback) {
        // if (window.keeper.debug) {
        //     console.log("PROTOBUF PAYLOAD REQUEST:", payload);
        // }

        const payload2Send = this.encodePB(Object.assign({}, payload, {}));
        const payloadMsg = this.requestObject.create(payload2Send);
        const payloadBytes = this.requestObject.encode(payloadMsg).finish();

        const transmissionKey = window.KeeperCrypto.random_256_bit_key();
        const publicKeyId = this.transmissionPublicKey;
        const publicKey = this.transmissionPublicKeys[publicKeyId];
        const encryptedSessionToken = window.KeeperCrypto.base64urlsafe_to_bytes(
            payload2Send.sessionToken
        );
        const encryptedTransmissionKey = this.publicKeyEncrypt(transmissionKey, publicKey);

        const encryptedRequestPB = this.encryptRequestPB(
            publicKeyId,
            transmissionKey,
            encryptedTransmissionKey,
            encryptedSessionToken,
            payloadBytes
        );

        const xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.responseType = 'arraybuffer';
        xhr.timeout = 30000;
        xhr.overrideMimeType('application/octet-stream');

        xhr.onloadend = e => {
            this.handleResponse(xhr.response, transmissionKey, xhr.status === 200, callback);
        };

        xhr.onerror = e => {
            this.handleResponse(xhr.response, transmissionKey, false, callback);
        };

        xhr.onabort = e => {
            this.handleResponse(xhr.response, transmissionKey, false, callback);
        };

        xhr.ontimeout = e => {
            this.handleResponse(xhr.response, transmissionKey, false, callback);
        };

        xhr.send(encryptedRequestPB);
    }

    public handleResponse(res, transmissionKey, success, callback) {
        try {
            // Encrypted ArrayBuffer Response
            res = this.decodePB(res, transmissionKey);
            res = JSON.parse(res);
        } catch (e) {
            try {
                // Unencrypted ArrayBuffer Response
                if (res.byteLength === 0) {
                    // Empty Response
                    callback(true, {});
                    return;
                }

                res = this.convertToString(res);
                res = JSON.parse(res);
            } catch (e) {
                callback(false, res);
                return;
            }
        }

        if (res.key_id) {
            if (this.retryCount >= 3) {
                //console.log("%cProtoBuf was unable to grab new public key.", "color: red;");
                callback(false, {});
                return;
            }

            this.retryCount++;
            //console.log("%cProtoBuf grabbed new public key. Retrying. (" + this.retryCount + ")", "color: green;");
            this.transmissionPublicKey = res.key_id;
            this.sendAsync(this.endpoint, this.setCallback, this.payload, this.callback);
        } else {
            callback(success, res);
            return;
        }
    }
}

export default ProtoBuf;
